// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from './dashboard-location-preferences.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME);

export const selectShowSkeleton = createSelector(
  currentState,
  (state: State) => state.isLoading,
);

export const selectShowError = createSelector(
  currentState,
  (state: State) => state.isError,
);

export const selectShowList = createSelector(
  currentState,
  (state: State) => state.locationPreferencesResponse?.clientLocationPreferences?.length > 0 && state.showList,
);

export const selectShowChart = createSelector(
  currentState,
  (state: State) => state.locationPreferencesResponse?.clientLocationPreferences?.length > 0 && !state.showList,
);

export const selectShowEmpty = createSelector(
  currentState,
  (state: State) => state.locationPreferencesResponse?.clientLocationPreferences?.length === 0,
);

export const selectShowSection = createSelector(
  currentState,
  (state: State) => state.isLoading || state.locationPreferencesResponse?.clientLocationPreferences?.length > 0,
);

function getClientLocationPreference(state: State) {
  return state
    .locationPreferencesResponse
    .clientLocationPreferences
    .find((clientLocationPreference) => clientLocationPreference.location.name === state.filter);
}

export const selectClientLocationPreferences = createSelector(
  currentState,
  (state: State) => state.locationPreferencesResponse
    ? getClientLocationPreference(state)
    : undefined,
);

export const selectClientLocationName = createSelector(
  currentState,
  (state: State) => state.locationPreferencesResponse
    ? getClientLocationPreference(state)?.location?.name
    : undefined,
);

export const selectLocations = createSelector(
  currentState,
  (state: State) => state.locationPreferencesResponse ? state.locationPreferencesResponse.clientLocationPreferences.map(a => a.location.name) : undefined,
);
